// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3RLZS","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__26NTb"};